import React from "react";

/**
 * Official brand logo of Appartamenti La Piazzetta.
 * Rendered from public/brand/*.webp (tinted bronze, transparent).
 *
 *  - variant="mark": tree-in-house crest only (used in the sticky header and small spots)
 *  - variant="full": full lockup with the "La Piazzetta · Appartamenti" wordmark (hero)
 */
export default function Logo({ className = "w-14 h-14", variant = "full" }) {
  const src = variant === "mark" ? "/brand/logo-mark.webp" : "/brand/logo.webp";
  return (
    <img
      src={src}
      alt="Appartamenti La Piazzetta"
      className={`${className} object-contain select-none`}
      draggable={false}
      data-testid="brand-logo"
      loading="eager"
    />
  );
}
